import { isNil, isNonEmptyArray, isNonEmptyObject } from '@/utils/checks'
import { SearchState } from '@/types/models'
export const isOnlyLocationChange = ({ state }: { state: SearchState }) => {
  if (isNonEmptyObject(state?.refinementList)) {
    return (
      Object.keys(state.refinementList).every((key) => key === 'locations') &&
      !isNil(state?.refinementList?.locations) &&
      isNonEmptyArray(state?.refinementList?.locations)
    )
  }
  return false
}
